<!-- 代理商详情 -->
<template>
  <div class="agentData">
    <div class="caozuo">
      <el-button @click="$router.go(-1)">返回</el-button>
    </div>
    <div class="agent_data" v-if="$route.query.is_proAgent!=0 ">
      <div class="data">
        <h3>用户数据</h3>
        <div class="item_conent">
          <div
            class="item_data"
            v-for="(item, index) in data1"
            :key="index"
            @click="linkDate(item)"
          >
            <img src="/static/img/icon/data.png" alt />
            <div class="cursor">
              <div>{{ item.title }}</div>
              <div>{{ item.value }}</div>
            </div>
          </div>
        </div>
      </div>
      <div class="data data1">
        <h3>今日数据</h3>
        <div class="item_conent">
          <div
            @click="linkDate(item)"
            v-for="(item, index) in data2"
            :key="index"
            class="item_data"
          >
            <img src="/static/img/icon/seed.png" alt />
            <div class="cursor">
              <div>{{ item.title }}</div>
              <div>{{ item.value }}</div>
            </div>
          </div>
        </div>
      </div>

      <div class="data data3">
        <h3>简历数据分布</h3>
        <div class="item_conent">
          <div
            @click="data3Click(item)"
            v-for="(item, index) in data3"
            :key="index"
            class="item_data"
          >
            <img src="/static/img/icon/resume.png" alt />
            <div class="cursor">
              <div>{{ item.title }}</div>
              <div>{{ item.value }}</div>
            </div>
          </div>
        </div>
      </div>

      <div class="data data3">
        <h3>简历线索数据分布</h3>
        <div class="item_conent">
          <div v-for="(item, index) in radar_data" :key="index" class="item_data">
            <img src="/static/img/icon/xiansuo.png" alt />
            <div class="cursor">
              <div>{{ item.title }}</div>
              <div>{{ item.value }}</div>
            </div>
          </div>
        </div>
      </div>
      <div class="data data3">
        <h3>30日数据</h3>
        <div class="item_conent">
          <div
            @click="linkDate_mon(item, false)"
            v-for="(item, index) in data_mon"
            :key="index"
            class="item_data"
          >
            <img src="/static/img/icon/yysj-jjfzgl02.png" alt />
            <div class="cursor">
              <div>{{ item.title }}</div>
              <div>{{ item.value }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="agent_data" v-else>
      <div class="data">
        <h3 style="width:100%">用户数据</h3>
        <div class="item_conent">
          <div
            class="item_data"
            v-for="(item, index) in agent_data"
            :key="index"
            @click="linkDate(item)"
          >
            <img src="/static/img/icon/data.png" alt />
            <div class="cursor">
              <div>{{ item.title }}</div>
              <div>{{ item.value }}</div>
            </div>
          </div>
        </div>
      </div>
      <div class="data">
        <h3 style="width:100%">简历和雷达数据</h3>
        <div class="item_conent">
          <div
            class="item_data"
            v-for="(item, index) in agent_resume_data"
            :key="index"
            @click="linkDate(item)"
          >
            <img src="/static/img/icon/resume.png" alt />
            <div class="cursor">
              <div>{{ item.title }}</div>
              <div>{{ item.value }}</div>
            </div>
          </div>
        </div>
      </div>
      <div class="data">
        <h3 style="width:100%">今日数据</h3>
        <div class="item_conent">
          <div
            class="item_data"
            v-for="(item, index) in agent_login_data"
            :key="index"
            @click="linkDate(item)"
          >
            <img src="/static/img/icon/seed.png" alt />
            <div class="cursor">
              <div>{{ item.title }}</div>
              <div>{{ item.value }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import { require } from "@/utils/http_request.js";
export default {
  //import引入的组件需要注入到对象中才能使用
  components: {},
  data() {
    //这里存放数据
    return {
      agent_data: [
        {
          title: "用户总数",
          value: 0,
          type: "all_counts",
          src: "all_company",
        },
        {
          title: "正常用户",
          value: 0,
          type: "user_counts",
          src: "use_company",
        },
        {
          title: "到期用户",
          value: 0,
          type: "past_due_counts",
          src: "pass_due_company",
        },
        {
          title: "付费用户",
          value: 0,
          type: "agent_pay_user_count",
          src: "pay_company",
        },
        {
          title: "充值用户",
          value: 0,
          type: "agent_seed_user_count",
          src: "send_company",
        },
        {
          title: "体验用户",
          value: 0,
          type: "agent_experience_user_count",
          src: "experience_company",
        },
        {
          title: "零工用户",
          value: 0,
          type: "odd_count",
          src: "odd_data",
        },
      ],
      pro_agent_data: [
        {
          title: "用户总数",
          value: 0,
          type: "all_counts",
          src: "all_company",
        },
        {
          title: "正常用户",
          value: 0,
          type: "use_counts",
          src: "use_company",
        },
        {
          title: "到期用户",
          value: 0,
          type: "past_due_counts",
          src: "pass_due_company",
        },
        {
          title: "付费用户",
          value: 0,
          type: "pay_user_count",
          src: "pay_company",
        },
        {
          title: "充值用户",
          value: 0,
          type: "seed_user_count",
          src: "send_company",
        },
        {
          title: "体验用户",
          value: 0,
          type: "experience_user_count",
          src: "experience_company",
        }
      ],
      agent_resume_data: [
        {
          //能点击详情时    加   is_is:true
          title: "城市总简历",
          value: 0,
          type: "all_resume_count",
          src: "all_company",
          is_is: true,
        },
        {
          title: "简历总数",
          value: 0,
          type: "all_agent_resume_count",
          src: "all_agent_resume",
        },
        {
          title: "城市线索总数",
          value: 0,
          type: "all_clue_count",
          src: "all_company",
          is_is: true,
        },
        {
          title: "线索总数",
          value: 0,
          type: "all_agent_clue_count",
          src: "all_agent_clue",
        },
      ],
      agent_login_data: [
        {
          title: "今日登录",
          value: 0,
          type: "login_in_count",
          src: "login_in",

        },
        {
          title: "今日完善简历",
          value: 0,
          type: "setting_resume_count",
          src: "",
          is_is: true,
        },
        {
          title: "今日投递简历",
          value: 0,
          type: "send_resume_count",
          src: "send_resume",
        },
        {
          title: "今日添加JD",
          value: 0,
          type: "create_jd_count",
          src: "create_jd",
        },
        {
          title: "今日完善公司",
          value: 0,
          type: "setting_company_count",
          src: "setting_company",
        },
        {
          title: "今日雷达线索",
          value: 0,
          type: "resume_radar_count",
          src: "radar_list",
        },
      ],
      data2: [
        {
          title: "今日登录",
          value: 0,
          type: "login_in_count",
          id: 0,
          src: "login_in",
        },
        {
          title: "今日简历下载",
          value: 0,
          type: "download_count",
          id: 1,
          src: "download_resume",
        },
        {
          title: "今日完善简历",
          value: 0,
          type: "setting_resume_count",
          id: 1,
          src: "setting_resume",
        },
        {
          title: "今日投递简历",
          value: 0,
          type: "send_resume_count",
          id: 1,
          src: "send_resume",
        },
        {
          title: "今日添加JD",
          value: 0,
          type: "create_jd_count",
          id: 2,
          src: "create_jd",
        },
        {
          title: "今日完善公司",
          value: 0,
          type: "setting_company_count",
          id: 0,
          src: "setting_company",
        },
        // {
        //   title: "今日签到",
        //   value: 0,
        //   type: "sign_in_count",
        //   id: 0,
        //   src: "sign_in"
        // },
        {
          title: "今日雷达线索",
          value: 0,
          type: "resume_radar_count",
          id: 1,
          src: "radar_list",
        },
      ],
      data1: [
        {
          title: "用户总数",
          value: 0,
          type: "all_counts",
          src: "all_company",
        },
        {
          title: "到期数量",
          value: 0,
          type: "past_due_counts",
          src: "pass_due_company",
        },
        {
          title: "正常用户",
          value: 0,
          type: "use_counts",
          src: "use_company",
        },
        {
          title: "简历总数",
          value: 0,
          type: "big_resume_count",
          src: "big_resume_count",
          is_is: 1,
        },
        {
          title: "线索总数",
          value: 0,
          type: "small_resume_count",
          src: "small_resume_count",
          is_is: 1,
        },
        {
          title: "充值客户",
          value: 0,
          type: "seed_user_count",
          src: "seed_user",
        },
        {
          title: "体验客户",
          value: 0,
          type: "experience_user_count",
          src: "experience_user",
        },
        {
          title: "付费客户",
          value: 0,
          type: "pay_user_count",
          src: "pay_user",
        },
        {
          title: "零工用户",
          value: 0,
          type: "odd_pay_user_count",
          src: "odd_data",
        },
        // {
        //   title: "礼金数",
        //   value: 0,
        //   type: "cash_data",
        //   src: "cash_data"
        // }
      ],
      data3: [],
      radar_data: [],
      data_mon: [
        {
          title: "30日登录",
          value: 0,
          type: "login_in_count",
          id: 0,
          src: "login_in",
        },
        {
          title: "30日简历下载",
          value: 0,
          type: "down_resume_count",
          id: 1,
          src: "download_resume",
        },
        {
          title: "30日新增用户",
          value: 0,
          type: "create_user_count",
          id: 1,
          src: "create_user",
        },
        {
          title: "30日完善简历",
          value: 0,
          type: "setting_resume_count",
          id: 1,
          src: "setting_resume",
        },
        {
          title: "30日投递简历",
          value: 0,
          type: "send_resume_count",
          id: 1,
          src: "send_resume",
        },
        {
          title: "30日添加JD",
          value: 0,
          type: "create_jd_count",
          id: 2,
          src: "create_jd",
        },
        {
          title: "30日完善公司",
          value: 0,
          type: "setting_company_count",
          id: 0,
          src: "setting_company",
        },
        // {
        //   title: '30日签到',
        //   value: 0,
        //   type: 'sign_in_count',
        //   id: 0,
        //   src: 'sign_in',
        // },
        {
          title: "30日雷达线索",
          value: 0,
          type: "radar_count",
          id: 1,
          src: "radar_list",
        },
      ],
    };
  },
  //监听属性 类似于data概念
  computed: {},
  //监控data中的数据变化
  watch: {},
  //方法集合
  methods: {
    init() {
      if (this.$route.query.is_proAgent == 0) {
        let obj = {
          username: this.$route.query.id,
        };
        require("post", "/hr24_index_data/v1/agent_home_page/", obj).then(
          (res) => {
            if (!res.code) {
              this.agent_data.map((item, index) => {
                let prop = item.type;
                item.value = res.data[prop];
              });
            }
          }
        );
        require("post", "/hr24_index_data/v1/agent_data/", obj).then((res) => {
          if (!res.code) {
            this.agent_resume_data.map((item, index) => {
              let prop = item.type;
              item.value = res.data[prop];
            });
          }
        });
        require("post", "/hr24_index_data/v1/agent_day_statistics/", obj).then(
          (res) => {
            if (!res.code) {
              this.agent_login_data.map((item, index) => {
                let prop = item.type;
                item.value = res.data[prop];
              });
            }
          }
        );
      } else {
        let obj = {
          username: this.$route.query.id,
        };
        require("post", "/hr24_index_data/v1/province_agent_home_page/", obj).then(
          (res) => {
            if (!res.code) {
              this.data1.map((item, index) => {
                let prop = item.type;
                item.value = res.data[prop] || 0;
              });
              // this.pro_agent_data.map((item, index) => {
              //   let prop = item.type
              //   item.value = res.data[prop]
              // })
            }
          }
        );
        require("post", "/hr24_index_data/v1/province_agent_day_statistics/", obj).then(
          (res) => {
            if (!res.code) {
              // this.cash_data = res.data.cash_data
              this.data2.map((item, index) => {
                let prop = item.type;
                item.value = res.data[prop] || 0;
              });
            }
          }
        );
        require("post", "/hr24_index_data/v1/province_agent_resume_data/", obj).then(
          (res) => {
            if (!res.code) {
              console.log(
                "/hr24_index_data/v1/province_agent_resume_data/",
                res.data
              );
              let resume_count_city = res.data.city_list;
              let radar_count = res.data.radar_count;
              for (let i in resume_count_city) {
                this.data3.push({
                  title: i,
                  value: resume_count_city[i],
                });

                this.data1[3].value += resume_count_city[i];
              }
              for (let i in radar_count) {
                this.radar_data.push({
                  title: i,
                  value: radar_count[i],
                });
                this.data1[4].value += radar_count[i];
              }
            }
          }
        );
        require("post", "/hr24_index_data/v1/province_agent_month_all_count/", obj).then(
          (res) => {
            if (!res.code) {
              this.data_mon.map((item, index) => {
                let prop = item.type;
                item.value = res.data[prop];
                return item;
              });
            }
          }
        );
      }
    },
    data3Click(e) {
      console.log(e);
      if (e.title && this.$cookies.get("auth_grade") != 90) {
        this.$router.push({ path: "/city", query: { src: e.title } });
      }
    },
    linkDate_mon(e, name) {
      console.log(name);
      if (e.src) {
        this.$router.push({
          path: "/line_ech",
          query: { src: e.src, title: e.title, name: name },
        });
      }
    },
    linkDate(e) {
      if (e.is_is) {
        // this.$message.warning("暂不开放");
        return false;
      }
      console.log(e);
      if (e.src && this.$route.query.is_proAgent == 0) {
        this.$router.push({
          path: "/agentData_value",
          query: { src: e.src, id: this.$route.query.id },
        });
      }
      if (e.src && this.$route.query.is_proAgent == 1) {
        this.$router.push({
          path: "/pro_agentValue",
          query: { src: e.src, id: this.$route.query.id },
        });
      }
    },
  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {
    console.log(this.$route.query.is_proAgent == 0, "acsas asvggasvcghvasgh");
    this.init();
  },
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {},
  beforeCreate() {}, //生命周期 - 创建之前
  beforeMount() {}, //生命周期 - 挂载之前
  beforeUpdate() {}, //生命周期 - 更新之前
  updated() {}, //生命周期 - 更新之后
  beforeDestroy() {}, //生命周期 - 销毁之前
  destroyed() {}, //生命周期 - 销毁完成
  activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style  scoped>
/* //@import url(); 引入公共css类 */
.agentData {
  position: relative;
  top: 80px;
  left: 200px;
  width: calc(100% - 220px);
  /* background: rgb(253, 88, 88); */
  min-height: 80vh;
  margin-bottom: 50px;
}
.cursor {
  cursor: pointer;
}

.item_conent {
  width: 100%;
  height: 220px;
  display: flex;
  box-sizing: border-box;
  flex-wrap: wrap;
  justify-content: start;
}
.item_data {
  display: flex;
  position: relative;
  z-index: 999;
  height: auto;
}

.data {
  width: 100%;
}
.data > h3 {
  width: 84%;
  padding: 0 0 12px 0;
  border-bottom: #bdbdbd solid 1px;
}

img {
  height: 30px;
  widows: 30px;
  margin-right: 10px;
  z-index: 200;
}

.data > .item_conent > div {
  margin-right: 30px;
  width: 15%;
}

.item_data div:first-child {
  color: #303030;
  font-size: 14px;
  margin-bottom: 20px;
}
.item_data div:last-child {
  color: #000;
  font-weight: bold;
  font-size: 20px;
}

.agent_data {
  position: relative;
  width: 90%;
  margin: auto;
  z-index: 11;
}
.cursor {
  cursor: pointer;
}
.data3 {
  /* margin-top: 16px;
  height: 220px; */
  display: flex;
  box-sizing: border-box;
  flex-wrap: wrap;
  justify-content: start;
  padding-top: 10px;
}

.main {
  margin-top: 46px;
  background: #ffff;
  border-radius: 4px;
  padding: 50px;
  min-height: 90vh;
}

.alldata {
  display: flex;
}

.all_chart {
  width: 50%;
}

.chart {
  width: 100%;
  display: flex;
  height: 230px;
  align-items: center;
  margin-bottom: 100px;
}

.all_data {
  width: 50%;
  z-index: 200;
}
.item_conent {
  width: calc(100% - 24px);
  height: 224px;
  padding: 12px;
  display: flex;
  box-sizing: border-box;
  flex-wrap: wrap;
  justify-content: start;
  overflow: auto;
  background: #f7f7f7;
  border-radius: 12px;
}
.item_data {
  display: flex;
  position: relative;
  z-index: 999;
  height: 100px;
}

.data {
  width: 100%;
}
.data > h3 {
  width: 100%;
  padding: 0 0 12px 0;
  border-bottom: #bdbdbd solid 1px;
}

img {
  height: 30px;
  widows: 30px;
  margin-right: 10px;
  z-index: 200;
}

.data > .item_conent > div {
  margin-right: 30px;
  width: 20%;
}

.item_data div:first-child {
  color: #303030;
  font-size: 14px;
  margin-bottom: 20px;
}
.item_data div:last-child {
  color: #000;
  font-weight: bold;
  font-size: 20px;
}
.agent_data {
  position: relative;
  z-index: 10;
}
.kong {
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/agentManagement/agentData.vue